import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'defaultText', translationKey: 'text', label: 'Text', required: true },
];

export const AppStringEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'app-strings' });

  return (
    <Edit resource="app-strings" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Key" name="key" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Namespace" name="namespace" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
